(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.product-faq__item');
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-text-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.pitc__carousel').forEach(function(el) {
      var track = el.querySelector('.pitc__track');
      var dots = Array.prototype.slice.call(el.querySelectorAll('.pitc__dot'));
      var total = el.querySelectorAll('.pitc__slide').length;
      var current = 0;

      function goTo(index) {
        current = (index + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, i) {
          d.classList.toggle('active', i === current);
        });
      }

      var btnPrev = el.querySelector('.pitc__arrow--prev');
      var btnNext = el.querySelector('.pitc__arrow--next');

      if (btnPrev) btnPrev.addEventListener('click', function() { goTo(current - 1); });
      if (btnNext) btnNext.addEventListener('click', function() { goTo(current + 1); });

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); });
      });

      // ─── Swipe tactile ───
      var wrapper = el.querySelector('.pitc__track-wrapper');
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var isHorizontalSwipe = false;

      wrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        isHorizontalSwipe = false;
      }, { passive: true });

      wrapper.addEventListener('touchmove', function(e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
        var deltaY = e.touches[0].clientY - touchStartY;
        if (!isHorizontalSwipe && Math.abs(touchDeltaX) > Math.abs(deltaY)) {
          isHorizontalSwipe = true;
        }
        if (isHorizontalSwipe) e.preventDefault();
      }, { passive: false });

      wrapper.addEventListener('touchend', function() {
        if (isHorizontalSwipe && Math.abs(touchDeltaX) > 50) {
          goTo(touchDeltaX < 0 ? current + 1 : current - 1);
        }
        isHorizontalSwipe = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
